import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { SharedFormPipesModule } from '@sondermind/iris/form-helpers';
import { IrisIconModule } from '@sondermind/iris/icon';

import { IrisDropdownComponent } from './dropdown.component';

@NgModule({
  imports: [
    CommonModule,
    IrisIconModule,
    ReactiveFormsModule,
    SharedFormPipesModule
  ],
  declarations: [
    IrisDropdownComponent
  ],
  exports: [
    IrisDropdownComponent
  ]
})
export class IrisDropdownModule { }
